import { Form } from 'antd';
import { RevxCheckbox } from 'components';
import { RevxCheckboxProps } from 'components/RevxCheckbox';
import { useOneofId } from '../hook/useOneofId';
import { useSvcGroupTitle } from '../hook/useSvcGroupTitle';
import { IOneofProps } from '../OneOfSvcs';

const CommonOneofSvcName = (props: IOneofProps) => {
  const { svcGroup } = props;
  const id = useOneofId(props);

  const svcName = useSvcGroupTitle({ svcGroup });

  const oneOfRadioProps: RevxCheckboxProps = {
    outSideRevxLayoutProps: {
      align: 'top',
      justify: 'left',
      wrap: 'wrap',
      className: 'jobconfig-jobOption-content-outSideOption-default',
      style: {
        paddingBottom: 0,
        marginTop: 20,
      },
    },
    inSideRevxLayoutProps: {
      align: 'top',
      justify: 'left',
      className: 'jobconfig-jobOption-content-inSideOption-default',
      style: {
        marginRight: 31,
      },
    },
    options: [
      {
        value: id,
        children: <span style={{ fontWeight: 'bold' }}>{svcName}</span>,
      },
    ],
  };

  return (
    <>
      {svcGroup?.isRequired ? (
        <div
          className="jobconfig-jobOption-content-subTitle"
          style={{ marginTop: 24 }}
        >
          {svcName}
        </div>
      ) : (
        <Form.Item name={[id, 'name']} noStyle>
          <RevxCheckbox {...oneOfRadioProps} />
        </Form.Item>
      )}
    </>
  );
};

export default CommonOneofSvcName;
